import triggerTracking from '@blueprint/tracking';

const EVENT = 'GAEvent';
const CATEGORY = 'discover';

export const trackAllPropertyNewsCTA = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'all_property_news_click',
        eventLabel: 'all_property_news'
    });
};

export const trackIndividualArticle = (articleTitle: string | undefined) => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'property_news_article_click',
        eventLabel: `${articleTitle?.toLowerCase()}`
    });
};

export const trackMainArticle = (articleTitle: string | undefined) => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'property_news_large_article_click',
        eventLabel: `${articleTitle?.toLowerCase()}`
    });
};
